var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"color/all",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M19 11v4H5v-4H2v7h2v2h2v-2h12v2h2v-2h2v-7z","stroke":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.5 9.5v4.1h11V9.5h2V5.7c0-.4-.3-.7-.7-.7H5.3c-.4 0-.8.3-.8.7v3.8h2z","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }